import { TS_Request } from 'Models/TravelSeller/Models/TS_Request';
import { Payload }    from 'Models/UI/Payload';

export class Request extends TS_Request {
    payload : Payload;
}